// extracted by mini-css-extract-plugin
export default {"linkCardLarge":"LinkCardLargeBlock_linkCardLarge__tnHcA","titleContainer":"LinkCardLargeBlock_titleContainer__CON5W","blue":"LinkCardLargeBlock_blue__F-6mX"};